import {
    UPDATE_SUBSCRIPTIONS,
    UNSUBSCRIBE_AUTOREPLENISHMENT,
    LOAD_SHIPPING_AND_PAYMENT_INFO,
    LOAD_CREDIT_CARD_LIST,
    UPDATE_AUTOREPLENISHMENT_SUBSCRIPTION,
    CLEAR_SUBSCRIPTIONS,
    LOAD_COUNTRIES
} from 'constants/actionTypes/autoReplenishment';

const initialState = {
    subscriptions: {
        subscriptions: [],
        numOfPagesLoaded: 0
    },
    shippingAndPaymentInfo: {
        shippingAddress: {},
        payment: {}
    },
    creditCards: [],
    countries: []
};

const reducer = function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case UPDATE_SUBSCRIPTIONS: {
            return {
                ...state,
                subscriptions: {
                    ...payload,
                    numOfPagesLoaded: state.subscriptions.numOfPagesLoaded + 1,
                    subscriptions: state.subscriptions.subscriptions.concat(payload.subscriptions)
                }
            };
        }
        case UNSUBSCRIBE_AUTOREPLENISHMENT: {
            return {
                ...state,
                subscriptions: {
                    ...payload,
                    subscriptions: state.subscriptions?.subscriptions?.filter(({ subscriptionId }) => subscriptionId !== payload.subscriptionId)
                }
            };
        }
        case LOAD_SHIPPING_AND_PAYMENT_INFO: {
            return {
                ...state,
                shippingAndPaymentInfo: payload
            };
        }
        case LOAD_CREDIT_CARD_LIST: {
            return {
                ...state,
                creditCards: payload.creditCards
            };
        }
        case UPDATE_AUTOREPLENISHMENT_SUBSCRIPTION: {
            return {
                ...state,
                shippingAndPaymentInfo: payload
            };
        }
        case CLEAR_SUBSCRIPTIONS: {
            return initialState;
        }
        case LOAD_COUNTRIES: {
            return {
                ...state,
                countries: payload
            };
        }
        default: {
            return state;
        }
    }
};

export default {
    reducer,
    initialState
};
